module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    class: {
      'time-label': _vm.isLabel
    }
  }, [(_vm.isLabel) ? [_c('span', {
    class: _vm.labelBgClass
  }, [_vm._t("default")], 2)] : _vm._e(), _vm._v(" "), (!_vm.isLabel) ? [_c('i', {
    class: [_vm.icon, _vm.iconBgClass]
  }), _vm._v(" "), (!_vm.end) ? _c('div', {
    staticClass: "timeline-item"
  }, [_vm._t("default")], 2) : _vm._e()] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a7075ae","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/timeline/timeline-item.vue
// module id = 42
// module chunks = 0